module.exports = __webpack_public_path__ + "static/media/alibaba.f0d56521.png";